<!--
 * @Author: your name
 * @Date: 2021-03-08 13:36:11
 * @LastEditTime: 2021-05-20 17:28:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/components/common/approveMember.vue
-->
<template>

  <div>
    <div class="filter-wrap" :gutter="20" v-if="show_box">
      <div v-if="this.approveObj.exStaff4Name" :span="6">四级审批人：{{this.approveObj.exStaff4Name}}</div>
      <div v-if="this.approveObj.exStaff3Name" :span="6">三级审批人：{{this.approveObj.exStaff3Name}}</div>
      <div v-if="this.approveObj.exStaff2Name" :span="6">二级审批人：{{this.approveObj.exStaff2Name}}</div>
      <div v-if="this.approveObj.exStaffYyName" :span="6">商务运营审批人：{{this.approveObj.exStaffYyName}}</div>
      <div v-if="this.approveObj.exStaff1Name" :span="6">商务总监审批人：{{this.approveObj.exStaff1Name}}</div>
      <div v-if="this.approveObj.exBossName" :span="6">老板审批人：{{this.approveObj.exBossName}}</div>
      <div v-if="this.approveObj.exTreasurerName" :span="6">财务审批人：{{this.approveObj.exTreasurerName}}</div>
      <div v-if="this.approveObj.exTreasurerLeaderName" :span="6">财务总监审批人：{{this.approveObj.exTreasurerLeaderName}}</div>
      <div v-if="this.approveObj.exCashierName" :span="6">出纳审批人：{{this.approveObj.exCashierName}}</div>
    </div>

    <div class="approve-list mb-10" v-if="
        this.approveObj.staff4NameList 
        || this.approveObj.staff3NameList
        || this.approveObj.staff2NameList
        || this.approveObj.staffYyNameList
        || this.approveObj.staff1NameList
        || this.approveObj.bossNameList
        || this.approveObj.treasurerNameList
        || this.approveObj.treasurerLeaderNameList
        || this.approveObj.cashierNameList">
      <span>(</span>
      <ul>
        <li v-if="this.approveObj.staff4NameList">
          四级可审批人：<span v-for="(item, index) in this.approveObj.staff4NameList" :key="index">{{item}}； </span>
        </li>
        <li v-if="this.approveObj.staff3NameList">
          三级可审批人：<span v-for="(item, index) in this.approveObj.staff3NameList" :key="index">{{item}}；</span> <span v-if="!this.approveObj.treasurerNameList">)</span>
        </li>
        <li v-if="this.approveObj.staff2NameList">
          二级可审批人：<span v-for="(item, index) in this.approveObj.staff2NameList" :key="index">{{item}}； </span>
        </li>
        <li v-if="this.approveObj.staffYyNameList">
          商务运营可审批人：<span v-for="(item, index) in this.approveObj.staffYyNameList" :key="index">{{item}}； </span>
        </li>
        <li v-if="this.approveObj.staff1NameList">
          商务总监可审批人：<span v-for="(item, index) in this.approveObj.staff1NameList" :key="index">{{item}}；</span> <span v-if="!this.approveObj.treasurerNameList">)</span>
        </li>
        <li v-if="this.approveObj.bossNameList">
          老板可审批人：<span v-for="(item, index) in this.approveObj.bossNameList" :key="index">{{item}}； </span>
        </li>
        <li v-if="this.approveObj.treasurerNameList">
          财务可审批人：<span v-for="(item, index) in this.approveObj.treasurerNameList" :key="index">{{item}}； </span>
        </li>
        <li v-if="this.approveObj.treasurerLeaderNameList">
          财务总监可审批人：<span v-for="(item, index) in this.approveObj.treasurerLeaderNameList" :key="index">{{item}}； </span>
        </li>
        <li v-if="this.approveObj.cashierNameList">
          出纳可审批人：<span v-for="(item, index) in this.approveObj.cashierNameList" :key="index">{{item}}； </span>)
        </li>
      </ul>
    </div>
    <div>
      <div v-if="auditStatus">审批状态：{{ approveConfig.getAppointed("statusStart", auditStatus, "") }}</div>
    </div>
  </div>
</template>

<script>
import { approveConfig } from "@/const/config/approve";
export default {
  props: ["approveObj", "auditStatus"],
  created() {
    console.log(this.approveObj);
  },
  data() {
    return {
      approveConfig,
      show_box:true,  //勿删除  其他地方使用隐藏  默认显示
      directorName: "", //直属主管
      chiefName: "", //业务总监
      treasurerName: "", //财务
      cashierName: "", // 出纳
      directorNameList: [], //直属主管列表
      chiefNameList: [], //业务总监列表
      treasurerNameList: [], //财务列表
      cashierNameList: [], //出纳列表
    };
  },
};
</script>

<style scoped lang="scss">
.approve-member {
  display: flex;
  color: #606266;
  margin-bottom: 10px;
  li {
    margin-right: 40px;
  }
}
.approve-list {
  display: inline-flex;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>